import { toast } from 'react-toastify'
import { useCallback, useEffect, useState } from 'react'

import styles from './styles.module.scss'

import api from '../../../../services/api'

import { Response } from '../../../../interfaces/types'

import { DataTable } from './dataTable'
import { IndicationList } from './indications'
import { FormPaymentPE } from './formAddPayment'
import { Modal } from '../../../../components/Modal'
import { Loader } from '../../../../components/Loader'
import { Pagination } from '../../../../components/Pagination'
import { SelectPerPage } from '../../../../components/Pagination/Select'

import { useAuth } from '../../../../hooks/useAuth'
import { formatMoney } from '@/utils/formatting/money'
import { Friend } from '@/domain/entities/friend.entity'
import { PE_INDICATOR_VALUE } from '../../../../constants'
import { FriendsRepository } from '../../repositories/friends.repository'

export function ShowPEFriends() {
  const { token } = useAuth()

  const [perPage, setPerPage] = useState(20)
  const [loading, setLoading] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [indicatorId, setIndicatorId] = useState('')
  const [dataFriend, setDataFriend] = useState({} as Friend)
  const [response, setResponse] = useState({} as Response<Friend>)

  const { count, data: friends } = response

  const getFriends = useCallback(async () => {
    const data = await FriendsRepository.GetInstance().list(token, {
      page: currentPage,
      perPage,
    })
    setResponse(data)
    setLoading(false)
  }, [])

  useEffect(() => {
    setLoading(true)
    getFriends()
  }, [])

  const handleOpenModal = (data: Friend) => {
    setDataFriend(data)
    setOpenModal(true)
  }

  const handleShowIndications = (id: string) =>
    setIndicatorId((state) => (state !== id ? id : ''))

  const handleRegister = async (dataForm) => {
    setLoading(true)
    const formattedData = { ...dataForm, friend_pe_id: dataFriend.id }
    const { data } = await api.post('/payments', formattedData)

    if (!data?.error) {
      const { data }: any = await api.get(
        `friends/by-code?code=${dataFriend.code}`,
      )

      if (!data?.friend) return toast('Código PE errado.', { type: 'error' })

      const { friend } = data

      await api.put('/friends', {
        ...friend,
        total_receivable: friend.total_receivable
          ? friend.total_receivable - +dataForm.amount_quantity
          : 0,
        total_received: friend.total_received
          ? friend.total_received + +dataForm.amount_quantity
          : +dataForm.amount_quantity,
      })
    }
    toast('Comprovante salvo com sucesso!')
    await getFriends()
    setOpenModal(false)
    setLoading(false)
  }

  return (
    <div className={styles.list_pe}>
      <h1>Administrador - Amigos PE</h1>

      <SelectPerPage perPage={perPage} setPerPage={setPerPage} />

      {loading && <Loader />}

      {openModal && (
        <Modal.Root title="Registrar pagamento" content="">
          <FormPaymentPE
            setOpenModal={setOpenModal}
            handleOnSubmit={handleRegister}
          />
        </Modal.Root>
      )}

      <table className={styles.table_container}>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Código</th>
            <th>Email</th>
            <th>Chave</th>
            <th>Telefone</th>
            <th>Telefone 2</th>
            <th>Quant.PE</th>
            <th>A receber</th>
            <th>Recebido</th>
            <th className={styles.actions}>Ações</th>
          </tr>
        </thead>

        <tbody>
          {friends?.length > 0 &&
            friends.map((friend) => {
              const totalReceivable =
                friend.total_receivable * PE_INDICATOR_VALUE
              const totalReceived = friend.total_received * PE_INDICATOR_VALUE

              return (
                <>
                  <DataTable
                    friend={friend}
                    indicatorId={indicatorId}
                    handleOpenModal={handleOpenModal}
                    handleShowIndications={handleShowIndications}
                    totalReceived={formatMoney(`${totalReceived},00`)}
                    totalReceivable={formatMoney(`${totalReceivable},00`)}
                  />

                  <IndicationList friend={friend} indicatorId={indicatorId} />
                </>
              )
            })}

          {friends?.length === 0 && (
            <tr>
              <td colSpan={10} style={{ textAlign: 'center' }}>
                Nenhum aluno encontrado
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Pagination
        count={count}
        page={currentPage}
        perPage={perPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  )
}
